import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  RESET_SELECTED_FILTERS,
  SET_DATES,
  SET_FILTERS_DIRTY,
  SET_FILTERS_LOADING,
  SET_LOADING,
  SET_MODULE_VIEW,
  SET_UPDATES_LOADING,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  UPDATE_FILTER
} from "./freezeLifecycleSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";
import { VIEW_OPTIONS } from "../constants";

export const initialState = {
  isLoading: true,
  initialRequest: false,
  updatesLoading: false,
  filtersLoading: false,
  filtersDirty: false,
  currentUser: {},
  chartsData: {},
  // Only used by Freeze History's "Date Range" preset filter.
  rangeOptions: [],
  filters: {
    membershipTypes: [],
    durationBuckets: []
  },
  selectedFilters: {
    moduleView: VIEW_OPTIONS[0],
    membershipTypes: [],
    durationBuckets: [],
    // Only used by Freeze History.
    startDate: null,
    endDate: null
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      filtersLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      rangeOptions: getRangeOptions(state.currentUser.calendarEndDate, state.currentUser.calendarStartDate),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOption(action.payload.endDate)
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_FILTERS_SUCCESS]: (state, { payload }) => {
      const membershipTypes = payload.membership_types || [];
      const durationBuckets = payload.duration_buckets || [];

      return {
        ...state,
        filters: { membershipTypes, durationBuckets },
        selectedFilters: { ...state.selectedFilters, membershipTypes, durationBuckets }
      };
    },
    [FETCH_DATA_SUCCESS]: (state, action) => ({
      ...state,
      chartsData: action.payload
    }),
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data
      }
    }),
    // Membership/duration filter options no longer depend on the date range (they're the store's
    // full catalog, not episode-derived) — only local state updates here; the table still waits
    // for Update like every other filter.
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOptionWithCustom(action)
      }
    }),
    // "Date Range" preset dropdown (e.g. Month To Date) — computes and applies matching start/end dates.
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        ...getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.currentUser.calendarStartDate
        ),
        rangeOption: action.payload
      }
    }),
    [RESET_SELECTED_FILTERS]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters,
        moduleView: state.selectedFilters.moduleView,
        membershipTypes: state.filters.membershipTypes,
        durationBuckets: state.filters.durationBuckets
      }
    }),
    [SET_MODULE_VIEW]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        moduleView: action.payload
      }
    })
  },
  initialState
);
